import { render, staticRenderFns } from "./project-api-source.vue?vue&type=template&id=4e6ac56b&scoped=true&"
import script from "./project-api-source.vue?vue&type=script&lang=js&"
export * from "./project-api-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ac56b",
  null
  
)

export default component.exports